import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { FormattedMessage } from '../../util/reactIntl';
import css from './Button.css';

const Button = props => {
  const { 
    className, 
    variant = 'primary', 
    isLoading = false, 
    disabled, 
    children, 
    ...rest 
  } = props;

  const classes = classNames(
    css.root,
    css[variant],
    { [css.loading]: isLoading },
    className
  );

  return (
    <button className={classes} disabled={disabled || isLoading} {...rest}>
      {isLoading ? (
        <div className={css.loaderContainer}>
          <span className={css.spinner} />
          <FormattedMessage id="Button.processing" />
        </div>
      ) : (
        children
      )}
    </button>
  );
};

export default Button;